import React from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '../cn';
import Input from '../form/Input';
/**
 * Standard search field: Search icon + `Input` sm + clear button when `onClear` + `clearable` + has value.
 *
 * Inherits all valid `Input` props (except `leftIcon`/`rightIcon`, used internally).
 */
export const TableFilterSearch = ({ onClear, clearable = true, className, value, defaultValue, type: _type, ...inputProps }) => {
    const hasValue = value != null
        ? String(value).length > 0
        : defaultValue != null && String(defaultValue).length > 0;
    const showClear = clearable && Boolean(onClear) && hasValue;
    return (React.createElement("div", { className: "relative w-full min-w-0" },
        React.createElement(Input, { ...inputProps, type: "text", value: value, defaultValue: defaultValue, leftIcon: React.createElement(Search, { className: "h-4 w-4", "aria-hidden": true }), inputSize: "sm", className: cn(showClear ? 'pr-10' : undefined, className) }),
        showClear ? (React.createElement("button", { type: "button", onClick: onClear, className: "absolute right-2 top-1/2 z-10 -translate-y-1/2 rounded-md p-1 text-[color:var(--form-fg-muted,rgba(11,18,32,0.66))] hover:bg-black/5 hover:text-[color:var(--form-fg,#0b1220)]", "aria-label": "Clear search" },
            React.createElement(X, { className: "h-4 w-4", "aria-hidden": true }))) : null));
};
export default TableFilterSearch;
